export default function LoadingSpinner({
    className = 'mr-1',
    style = {},
    width = '8px',
    height = '8px',
    loderStyle = {},
}) {
    return (
        <div id="loading-spinner" className={className} style={style}>
            <div className="spin-icon" style={{ width, height, ...loderStyle}}></div>
        </div>
    );
}
